import store from "../../store/store";
import {
  getRemoteAccess,
  restartShell,
} from "../../store/slice/health-monitor/device-details";
import { setModalType } from "../../store/slice/health-monitor/modal";

import { getPathFromURL } from "../url";

export const ModalConfig = {
  restartShell: {
    message: "Are you sure you want to restart device?",
    onConfirm: () => {
      store.dispatch(restartShell(getPathFromURL(4)));
      store.dispatch(setModalType(null));
    },
    onCancel: () => {
      store.dispatch(setModalType(null));
    },
  },
  remoteConnection: {
    message: "Are you sure you want to connect remotely?",
    onConfirm: () => {
      store.dispatch(
        getRemoteAccess(store.getState().deviceDetails.remoteControlId)
      );
      store.dispatch(setModalType(null));
    },
    onCancel: () => {
      store.dispatch(setModalType(null));
    },
  },
  error: {
    message: "Error Message",
    onConfirm: () => {
      store.dispatch(setModalType(null));
    },
    onCancel: null,
  },
  success: {
    message: "Success Message",
    onConfirm: () => {
      store.dispatch(setModalType(null));
    },
    onCancel: null,
  },
};

export const formattedErrorMessages = [
  "shellRestart",
  "remoteConnection",
  "shellUpdate",
  "genericError",
  "deviceNotFound",
  "dateTimeRange",
  "accessToken",
  "ErrorWhileRetrievingDevices",
];
